import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Typography } from "@mui/material";
import React from "react";
import {
  InfoBox,
  ListContainer,
  StyledCard,
  StyledNameField,
  StyledTitleField,
} from "./styles";

interface IEmployee {
  id: number;
  name: string;
  active?: boolean;
}

interface IEmployeeProps {
  employees: IEmployee[] | null;
  onEdit?: any;
}

const EmployeeList: React.FC<IEmployeeProps> = ({
  employees,
  onEdit,
}) => {

  const sortedEmployees = employees
    ? [...employees].sort((a, b) => Number(b.active) - Number(a.active))
    : null;

  return (
    <ListContainer>
      <StyledTitleField variant="h6">Lista de Funcionários</StyledTitleField>

      <ul style={{ margin: 0, padding: 0 }}>
        {sortedEmployees && sortedEmployees.length > 0 ? (
          sortedEmployees.map((employee) => (
            <StyledCard key={employee.id}>
              <InfoBox>
                <StyledNameField>
                  <strong>Nome:</strong> {employee.name}
                </StyledNameField>

                <Typography
                  variant="body2"
                  sx={{
                    color: employee.active ? "success.main" : "error.main",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                  }}
                >
                  {employee.active ? "● Ativo" : "● Inativo"}
                </Typography>
              </InfoBox>

              <IconButton onClick={() => onEdit(employee)}>
                <EditIcon />
              </IconButton>
            </StyledCard>
          ))
        ) : (
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            Nenhum funcionário encontrado.
          </Typography>
        )}
      </ul>
    </ListContainer>
  );
};

export default EmployeeList;